import React, { useState } from "react";
import s from "./Ranking.module.scss";
import SearchInput from "../../../../../../global components/Forms/SearchInput/SearchInput";
import Paginate from "../../../../../../global components/Paginate/Pagination";

import useSWR from "swr";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";
import { PaginatedAPIActivityType } from "../../../../../../libs/Utils/Types/APIManagement";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import RequestTable from "./local component/RequestTable";
function Ranking() {
  const token = UseAuthToken();
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageItems, setPageItems] = useState(100);
  const { data, isLoading, mutate } = useSWR<
    PaginatedAPIActivityType,
    any,
    any
  >(
    token
      ? [
          "api/admin/api-keys/activity",
          token,
          {
            ...(searchValue && { search: searchValue }),
            ...(currentPage && { page: currentPage }),
            ...(pageItems && { limit: pageItems }),
          },
        ]
      : null,
    swrFetcher
  );
  const handleSearch = (value: string) => {
    setSearchValue(value);
    // You can add your search logic here, e.g., fetching data based on the search term
  };
  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageItems(size);
  };
  return (
    <div className={s.wrapper}>
      <h3 className={s.title}>Key Activity Ranking</h3>
      <div className={s.tableWrapper}>
        <div className={s.head}>
          <div className={s.searchInput}>
            <SearchInput
              style={{ width: "100%", height: "100%" }}
              placeholder="Search by user name or request ID..."
              width={332}
              height={45}
              handleSearch={handleSearch}
            />
          </div>
          <div className={s.filterWrapper}>
            <Paginate
              onChange={handlePageChange}
              total={data?.pagination.totalItems || 0}
              pageSize={pageItems}
            />
          </div>
        </div>
        <RequestTable
          mutate={mutate}
          data={data?.data || []}
          loading={isLoading}
        />
      </div>
    </div>
  );
}

export default Ranking;
